// pp-company-orders.js — vista B2B "Órdenes de la Empresa" (rework 2026-07-27).
//
// Por qué existe: el rework anterior (#463, revertido en #464) cambió el look
// de las tarjetas y el cliente lo rechazó — quiere las tarjetas NATIVAS
// idénticas (snippets/pp-customer-orders-list.liquid), solo con una etiqueta de
// quién puso cada orden. Este script construye ese markup EXACTO (mismas
// clases pp-orders__*) por JS porque las órdenes vienen de un fetch al App
// Proxy (no de `customer.orders` de Liquid): el puente es por MIEMBRO de la
// cuenta (crm_contacts.account_id), no por el sello `orders.crm_account_id`
// (casi vacío — ver docs/superpowers/specs/2026-07-27-ordenes-empresa-rework-design.md).
//
// Flujo:
//   1. GET /apps/crm/customer-company. Si found:true → el cliente pertenece a
//      una empresa: oculta el bloque nativo [data-pp-native-orders] y muestra
//      este contenedor. Si found:false (o el fetch falla) → no toca nada, la
//      vista nativa de Liquid ya está renderizada y visible (cero regresión).
//   2. load(scope, page) → GET /apps/crm/customer-orders?scope=&page= y arma
//      un <li class="pp-orders__card"> por orden, reusando las mismas clases
//      del snippet nativo para heredar TODO su CSS (cero CSS de tarjeta nuevo).
//   3. "Ver detalle" no navega — es un acordeón: toggle de la clase
//      `is-expanded` que revela `.pp-orders__all-items` con el detalle
//      COMPLETO. Desde 2026-09-04 aplica a TODAS las órdenes (propias
//      incluidas): bajo cuentas nuevas `order.customer_url` manda a la
//      página hospedada de Shopify (otro diseño) y NO se usa.
//   4. "Comprar nuevamente" porta 1:1 el handler del <script> inline de
//      pp-customer-orders-list.liquid (POST /cart/add.js).
//
// Copy dinámico (badges, chip "Tuya"/"Puesta por", labels de acciones) viene
// de data-t-* en [data-pp-company-orders] — se arma en Liquid una sola vez
// desde las keys existentes de la tarjeta nativa (pp.customer.orders_list.* /
// pp.customer.order.status.* / pp.customer.order.fulfillment.*), sin agregar
// locale keys nuevas. Todo el DOM que incluye datos del backend se construye
// con textContent/setAttribute — nunca innerHTML con esos datos (los únicos
// innerHTML de este archivo son los <path>/<polyline> ESTÁTICOS de los iconos,
// idénticos a los del snippet nativo).

(function () {
  'use strict';

  var COMPANY_ENDPOINT = '/apps/crm/customer-company';
  var ORDERS_ENDPOINT = '/apps/crm/customer-orders';

  var root = document.querySelector('[data-pp-company-orders]');
  var nativeBlock = document.querySelector('[data-pp-native-orders]');
  if (!root) return;

  // En el editor del theme no hay sesión de cliente logueado.
  if (window.Shopify && window.Shopify.designMode) return;

  var listEl = root.querySelector('[data-pp-orders-ul]');
  var emptyEl = root.querySelector('[data-pp-orders-empty]');
  var paginationNav = root.querySelector('[data-pp-orders-pagination]');
  var prevBtn = root.querySelector('[data-pp-orders-prev]');
  var nextBtn = root.querySelector('[data-pp-orders-next]');
  var pageInfoEl = root.querySelector('[data-pp-orders-pageinfo]');
  var scopeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pp-scope]'));
  if (!listEl) return;

  // Chip de conteo junto al H1 "Mis Órdenes" (snippets/pp-customer-page-header.liquid,
  // fuera de [data-pp-company-orders] — vive en el header de la page). Arranca
  // con customer.orders_count (personales); si el cliente pertenece a una
  // empresa, la vista B2B lista el TOTAL de la empresa, así que hay que
  // resincronizar el chip a `data.total` en cada load() o queda desalineado
  // con lo que se está mostrando (Fix de review).
  var countEl = document.querySelector('[data-pp-orders-count]');
  // Conteo personal (customer.orders_count) que el header ya renderizó — se
  // restaura al volver a "Solo mías" (en "Todas" el load lo cambia al total
  // de la empresa).
  var initialCount = countEl ? countEl.textContent : null;

  function t(key) {
    return root.getAttribute('data-t-' + key) || '';
  }

  var dateFmt = new Intl.DateTimeFormat('es-MX', { day: '2-digit', month: 'short', year: 'numeric' });
  // Solo agrupa miles (coma) — el "$"/"MXN" y los decimales los arman a mano
  // las 2 funciones de abajo, cada una calcando un formato nativo distinto.
  var intFmt = new Intl.NumberFormat('es-MX', { maximumFractionDigits: 0 });

  function formatDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return dateFmt.format(d);
  }

  // Precio de ITEM = el filtro `money` de Shopify tal cual lo usa el nativo
  // (`{{ line_item.final_line_price | money }}`): money_format de la tienda,
  // SIN decimales, coma de miles, sufijo " MXN" (ver comentario en
  // snippets/pp-money-cents.liquid: "El money_format del store está
  // configurado sin decimales ($5,696 MXN)").
  function formatMoneyStore(pesos) {
    var n = typeof pesos === 'number' ? pesos : parseFloat(pesos || 0);
    if (isNaN(n)) n = 0;
    var neg = n < 0;
    return (neg ? '-$' : '$') + intFmt.format(Math.round(Math.abs(n))) + ' MXN';
  }

  // Total del header = calca snippets/pp-money-cents.liquid, que SIEMPRE
  // fuerza 2 decimales (independiente del money_format de la tienda) porque
  // el total exacto se necesita para el lookup de facturación CFDI. El
  // snippet Liquid recibe `amount` en CENTS; nuestro backend manda `total`
  // en PESOS (float), así que convertimos antes de aplicar la misma lógica
  // (pesos enteros con coma de miles + ".cc" + " MXN").
  function formatMoneyTotal(pesos) {
    var n = typeof pesos === 'number' ? pesos : parseFloat(pesos || 0);
    if (isNaN(n)) n = 0;
    var neg = n < 0;
    var cents = Math.round(Math.abs(n) * 100);
    var whole = Math.floor(cents / 100);
    var centsPart = cents % 100;
    var centsStr = centsPart < 10 ? '0' + centsPart : String(centsPart);
    return (neg ? '-$' : '$') + intFmt.format(whole) + '.' + centsStr + ' MXN';
  }

  // ── SVG icons (estáticos, idénticos a los del snippet nativo) ──────────
  var ICON_PATHS = {
    repurchase:
      '<path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/>' +
      '<path d="M21 3v5h-5"/>' +
      '<path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/>' +
      '<path d="M8 16H3v5"/>',
    tracking:
      '<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/>' +
      '<path d="M15 18H9"/>' +
      '<path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/>' +
      '<circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/>',
    feedback: '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>',
    detail: '<path d="M9 5l7 7-7 7"/>',
    invoice: '<circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>',
    download: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>',
    pending: '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>',
    closed: '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>',
    pin: '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>',
    calendar: '<rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>',
    receipt: '<path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"/><path d="M8 7h8"/><path d="M8 11h8"/><path d="M8 15h5"/>'
  };

  function svgIcon(name) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    // Markup estático de este archivo (no datos del backend) — seguro.
    svg.innerHTML = ICON_PATHS[name] || '';
    return svg;
  }

  function el(tag, className) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    return node;
  }

  // ── Mapeo de estatus → mismas clases/labels que el nativo ──────────────
  function financialMeta(status) {
    switch (status) {
      case 'paid':
        return { label: t('status-paid'), cls: 'pp-orders__badge--paid', tip: t('status-tip-paid') };
      case 'pending':
        return { label: t('status-pending'), cls: 'pp-orders__badge--pending', tip: t('status-tip-pending') };
      case 'refunded':
        return { label: t('status-refunded'), cls: 'pp-orders__badge--neutral', tip: t('status-tip-refunded') };
      case 'partially_refunded':
        return { label: t('status-partially-refunded'), cls: 'pp-orders__badge--neutral', tip: t('status-tip-partially-refunded') };
      case 'failed':
        return { label: t('status-failed'), cls: 'pp-orders__badge--neutral', tip: t('status-tip-failed') };
      default:
        return { label: status || '', cls: 'pp-orders__badge--neutral', tip: '' };
    }
  }

  // Recibe la orden completa (no solo el status): 'fulfilled' de Shopify
  // significa "enviado con guía", NO "entregado" — el badge "Entregado" solo
  // sale con delivered_at real (confirmación del rastreo en el backend).
  function fulfillmentMeta(order) {
    if (order.delivered_at) {
      return { label: t('fulfillment-delivered'), cls: 'pp-orders__badge--fulfilled', tip: t('fulfillment-tip-delivered') };
    }
    switch (order.fulfillment_status) {
      case 'fulfilled':
        return { label: t('fulfillment-fulfilled'), cls: 'pp-orders__badge--fulfilled', tip: t('fulfillment-tip-fulfilled') };
      case 'partial':
        return { label: t('fulfillment-partial'), cls: 'pp-orders__badge--pending', tip: t('fulfillment-tip-partial') };
      case 'unshipped':
        return { label: t('fulfillment-unshipped'), cls: 'pp-orders__badge--pending', tip: t('fulfillment-tip-unshipped') };
      default:
        return { label: t('fulfillment-processing'), cls: 'pp-orders__badge--neutral', tip: t('fulfillment-tip-processing') };
    }
  }

  function buildBadge(meta) {
    var span = el('span', 'pp-orders__badge ' + meta.cls);
    if (meta.tip) span.setAttribute('title', meta.tip);
    span.textContent = meta.label;
    return span;
  }

  function buildHeaderBlock(label, value) {
    var block = el('div', 'pp-orders__header-block');
    var l = el('span', 'pp-orders__header-label');
    l.textContent = label;
    var v = el('span', 'pp-orders__header-value');
    v.textContent = value;
    block.appendChild(l);
    block.appendChild(v);
    return block;
  }

  // Equivalente al filtro `truncate` de Liquid (el total incluye los puntos),
  // para que las columnas de esta lista corten igual que las de la nativa.
  function truncate(str, n) {
    var s = String(str == null ? '' : str);
    return s.length > n ? s.slice(0, n - 3) + '...' : s;
  }

  // "+ N productos más" — la key nativa es pluralizada ({{ count }} producto(s)
  // más); Liquid ya resolvió las 2 formas (one/other) con el dígito 1 y 2
  // respectivamente en data-t-more-items-one/-other. Sustituimos ese dígito
  // por el conteo real — evita tener que re-implementar pluralización en JS.
  function moreItemsText(extra) {
    var tmpl = extra === 1 ? t('more-items-one') : t('more-items-other');
    return tmpl.replace(/\d+/, String(extra));
  }

  // Badge de reembolso de UNA línea (null si la línea no tiene reembolso, o si
  // el backend es viejo y no manda los campos — degrada a como estaba).
  function buildRefundBadge(item) {
    var status = item && item.refund_status;
    if (status !== 'refunded' && status !== 'partially_refunded') return null;
    var label = t('status-refunded');
    if (status === 'partially_refunded') {
      var n = Number(item.refunded_quantity) || 0;
      var m = Number(item.quantity) || 0;
      label = n > 0 && m > 0 ? label + ' ' + n + ' de ' + m : t('status-partially-refunded');
    }
    if (!label) return null;
    var badge = buildBadge({ label: label, cls: 'pp-orders__badge--neutral', tip: '' });
    badge.classList.add('pp-orders__item-refund');
    return badge;
  }

  function buildItemLi(item, href) {
    var li = el('li', 'pp-orders__item');
    li.setAttribute('data-qty', item.quantity != null ? String(item.quantity) : '0');

    var thumb = el('span', 'pp-orders__item-thumb');
    if (item.image_url) {
      var img = document.createElement('img');
      img.src = item.image_url;
      img.alt = item.name || '';
      img.loading = 'lazy';
      img.width = 72;
      img.height = 72;
      thumb.appendChild(img);
    }
    var qtyBadge = el('span', 'pp-orders__item-qty-badge');
    // "unidades" hardcoded en español a propósito: el nativo hace lo mismo
    // (línea 187 de pp-customer-orders-list.liquid), replicado para paridad.
    qtyBadge.setAttribute('aria-label', (item.quantity || 0) + ' unidades');
    qtyBadge.textContent = item.quantity != null ? String(item.quantity) : '';
    thumb.appendChild(qtyBadge);
    li.appendChild(thumb);

    var body = el('div', 'pp-orders__item-body');

    // El CSS ya subraya el título al hover (afordancia de link): cuando hay
    // destino (orden propia), el título ES un link de verdad.
    var titleEl;
    if (href) {
      titleEl = document.createElement('a');
      titleEl.className = 'pp-orders__item-title';
      titleEl.href = href;
    } else {
      titleEl = el('span', 'pp-orders__item-title');
    }
    titleEl.textContent = item.name || '';
    body.appendChild(titleEl);

    var metaEl = el('p', 'pp-orders__item-meta');
    metaEl.textContent = t('qty') + ' ' + (item.quantity != null ? item.quantity : 0) + ' · ' + formatMoneyStore(item.line_price);
    body.appendChild(metaEl);

    // Reembolsos por línea (#6269). El backend (core.order_items_vigencia →
    // lineasDelPortal) manda `quantity` = cantidad EN PEDIDO (tras ediciones;
    // lo quitado por edición ni siquiera llega) y, aparte, `refunded_quantity`
    // + `refund_status` ('refunded' | 'partially_refunded' | null). Estándar
    // Shopify/Amazon: lo reembolsado NO se esconde, se ve marcado. Reembolso
    // total → badge "Reembolsado", precio tachado y miniatura atenuada (la
    // atenuación es lo único que se ve en móvil, donde el body va oculto).
    // Parcial → "Reembolsado N de M". El "de" va en español a propósito, igual
    // que "unidades" en el badge de cantidad (paridad con el nativo).
    var refundBadge = buildRefundBadge(item);
    if (refundBadge) {
      body.appendChild(refundBadge);
      if (item.refund_status === 'refunded') {
        li.classList.add('pp-orders__item--refunded');
        metaEl.classList.add('pp-orders__item-meta--refunded');
      }
    }

    if (item.sku) {
      var skuEl = el('p', 'pp-orders__item-sku');
      skuEl.textContent = t('sku') + ': ' + item.sku;
      body.appendChild(skuEl);
    }

    li.appendChild(body);
    return li;
  }

  function buildItemsList(items, href) {
    var ul = el('ul', 'pp-orders__items');
    ul.setAttribute('role', 'list');
    items.forEach(function (item) {
      ul.appendChild(buildItemLi(item, href));
    });
    return ul;
  }

  // ── Detalle completo (acordeón "Ver detalle") ──────────────────────────
  // Sub-secciones que se muestran ADEMÁS de los items, cuando el backend las
  // manda (degradan con gracia: si el campo es null, la sub-sección no se
  // renderiza). Reusa el look del detalle nativo (pp-order__* → replicado con
  // clases pp-orders__detail-* en pp-customer.css) para consistencia visual.
  function detailHeading(iconName, text) {
    var h = el('h4', 'pp-orders__detail-heading');
    h.appendChild(svgIcon(iconName));
    h.appendChild(document.createTextNode(text));
    return h;
  }

  function addLine(container, text, strong) {
    var p = el('p', 'pp-orders__detail-line');
    if (strong) {
      var s = document.createElement('strong');
      s.textContent = text;
      p.appendChild(s);
    } else {
      p.textContent = text;
    }
    container.appendChild(p);
    return p;
  }

  // 1. "Enviado A" — domicilio formateado. null → devuelve null (sin sección).
  function buildAddressSection(order) {
    var a = order.shipping_address;
    if (!a) return null;

    var section = el('div', 'pp-orders__detail-section');
    section.appendChild(detailHeading('pin', t('detail-ship-to')));

    if (a.name) addLine(section, a.name, true);
    if (a.company) addLine(section, a.company);
    if (a.address1) addLine(section, a.address1);
    if (a.address2) addLine(section, a.address2);

    var cityBits = [];
    if (a.city) cityBits.push(a.city);
    var regionBits = [];
    if (a.province) regionBits.push(a.province);
    if (a.zip) regionBits.push(a.zip);
    if (regionBits.length) cityBits.push(regionBits.join(' '));
    if (cityBits.length) addLine(section, cityBits.join(', '));

    if (a.country) addLine(section, a.country);
    if (a.phone) addLine(section, a.phone);

    return section;
  }

  // 2. "Entrega" — badge de fulfillment + fecha entregado/estimada.
  function buildDeliverySection(order) {
    var section = el('div', 'pp-orders__detail-section');
    section.appendChild(detailHeading('calendar', t('detail-delivery')));

    var badge = buildBadge(fulfillmentMeta(order));
    badge.classList.add('pp-orders__detail-badge');
    section.appendChild(badge);

    if (order.delivered_at) {
      var d = formatDate(order.delivered_at);
      if (d) addLine(section, t('delivered-on').replace('{date}', d));
    } else if (order.estimated_delivery) {
      var e = formatDate(order.estimated_delivery);
      if (e) addLine(section, t('estimated-delivery').replace('{date}', e));
    }

    return section;
  }

  // 3. "Guía Y Rastreo" — link de rastreo + número de guía + método.
  //    Sin ningún dato de tracking → null (sin sección).
  function buildTrackingSection(order) {
    if (!order.tracking_url && !order.tracking_number && !order.shipping_title) return null;

    var section = el('div', 'pp-orders__detail-section');
    section.appendChild(detailHeading('tracking', t('detail-tracking')));

    if (order.tracking_url) {
      var link = document.createElement('a');
      link.className = 'pp-orders__detail-track-link';
      link.href = order.tracking_url;
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = t('action-tracking') + ' →';
      section.appendChild(link);
    }
    if (order.tracking_number) {
      addLine(section, t('tracking-number').replace('{number}', order.tracking_number));
    }
    if (order.shipping_title) {
      addLine(section, t('shipping-method').replace('{method}', order.shipping_title));
    }

    return section;
  }

  // Grid con las 3 sub-secciones de arriba. Devuelve null si ninguna aplica.
  function buildDetailInfo(order) {
    var sections = [buildAddressSection(order), buildDeliverySection(order), buildTrackingSection(order)].filter(Boolean);
    if (!sections.length) return null;
    var grid = el('div', 'pp-orders__detail');
    sections.forEach(function (s) {
      grid.appendChild(s);
    });
    return grid;
  }

  // 4. "Resumen" — subtotal/envío/IVA/total. Oculta líneas null; Total siempre.
  //    Mismo formato de dinero que el header (formatMoneyTotal = 2 decimales,
  //    calca pp-money-cents que usa el detalle nativo para todas sus líneas).
  function summaryRow(label, pesos, isTotal) {
    var row = el('div', 'pp-orders__summary-row' + (isTotal ? ' pp-orders__summary-row--total' : ''));
    var l = el('span', 'pp-orders__summary-label');
    l.textContent = label;
    var v = el('span', 'pp-orders__summary-value');
    v.textContent = formatMoneyTotal(pesos);
    row.appendChild(l);
    row.appendChild(v);
    return row;
  }

  function buildSummarySection(order) {
    var section = el('div', 'pp-orders__summary');
    section.appendChild(detailHeading('receipt', t('detail-summary')));

    if (order.subtotal != null) section.appendChild(summaryRow(t('summary-subtotal'), order.subtotal, false));
    if (order.shipping_total != null) section.appendChild(summaryRow(t('summary-shipping'), order.shipping_total, false));
    if (order.tax != null) section.appendChild(summaryRow(t('summary-tax'), order.tax, false));
    section.appendChild(summaryRow(t('summary-total'), order.total, true));

    return section;
  }

  // ── Toast (portado 1:1 del <script> inline de pp-customer-orders-list.liquid) ──
  function showToast(message, kind) {
    var toast = document.createElement('div');
    toast.className = 'pp-order__toast pp-order__toast--' + (kind || 'ok');
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 300);
    }, 2400);
  }

  function wireRepurchase(btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.disabled) return;

      var raw = btn.getAttribute('data-pp-repurchase-items');
      if (!raw) return showToast('No hay artículos para reordenar', 'err');

      var items;
      try {
        items = JSON.parse(raw);
      } catch (_) {
        return showToast('Error al leer la orden', 'err');
      }
      if (!Array.isArray(items) || items.length === 0) {
        return showToast('No hay artículos para reordenar', 'err');
      }

      var origText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Agregando…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function () {
          showToast('Productos agregados al carrito', 'ok');
          document.dispatchEvent(new CustomEvent('pp:cart-drawer:open'));
          document.dispatchEvent(new CustomEvent('pp:cart-updated'));
        })
        .catch(function () {
          showToast('Algunos artículos no están disponibles', 'err');
        })
        .finally(function () {
          btn.disabled = false;
          btn.textContent = origText;
        });
    });
  }

  // ── Facturar: mismo state-machine que snippets/pp-order-invoice-actions.liquid ──
  // (compartido por el detalle y la lista nativa). 4 estados, en orden de
  // prioridad — igual que el snippet:
  //   1. has_invoice (=is_invoiced)        → "Ver Factura" (--download, clickeable)
  //   2. financial_status != 'paid'         → "Paga tu orden para facturar" (--invoice-pending, ámbar, SÍ abre el modal)
  //   3. paid + dentro de la ventana        → "Facturar" (--invoice-cta), abre el modal a emitir
  //   4. paid + mes distinto (ya cerrado)   → "Facturación cerrada" (--invoice-closed), <span> pasivo, NO abre modal
  //
  // Los botones que abren el modal (2/3) llevan data-order-items + data-order-date
  // además de data-order-number/-total-cents, igual que el nativo, para que
  // pp-factura-modal.js renderice el resumen "esto vas a facturar" al instante
  // sin esperar al lookup (#3383). data-order-date se pasa tal cual llega del
  // backend (ISO 8601) — pp-factura-modal.js solo hace `new Date(iso)` con
  // ese valor (ver su función formatDate), no necesita el %z exacto de
  // Shopify (que además solo puede calcularse server-side con el tz de la
  // tienda, no en el navegador del cliente).
  // Ventana de facturación: mes en curso, o mes pasado si hoy es día 1-9.
  // El techo del día 9 es regla nuestra (cierre contable), NO del SAT. Espejo
  // de snippets/pp-invoice-window.liquid y de la cláusula puede_facturar de
  // core.public_order_invoice_lookup — si cambia uno, cambian los tres.
  var VENTANA_DIAS_FACTURABLE = 9;

  function isInvoiceWindowOpen(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return false;
    var now = new Date();

    var mismoMes =
      d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth();
    if (mismoMes) return true;

    // Mes pasado, dentro de la gracia.
    if (now.getDate() > VENTANA_DIAS_FACTURABLE) return false;
    var mesPasado = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    return (
      d.getFullYear() === mesPasado.getFullYear() &&
      d.getMonth() === mesPasado.getMonth()
    );
  }

  function buildOrderItemsJson(items) {
    return JSON.stringify(
      items.map(function (it) {
        var lineTotal = typeof it.line_price === 'number' ? it.line_price : parseFloat(it.line_price || 0);
        if (isNaN(lineTotal)) lineTotal = 0;
        return { name: it.name || '', quantity: it.quantity != null ? it.quantity : 0, line_total: lineTotal };
      })
    );
  }

  function buildInvoiceAction(order, items) {
    var orderNumber = order.order_number != null ? String(order.order_number) : '';
    var cents = Math.round((typeof order.total === 'number' ? order.total : parseFloat(order.total || 0)) * 100);

    // 1. Ya facturada → MISMO slot que snippets/pp-order-invoice-actions.liquid:
    //    un spinner que pp-customer-order.js resuelve a "Descargar PDF" /
    //    "Descargar XML" matcheando la orden contra las facturas del CRM, con
    //    "Ver factura" (modal) como fallback oculto si no hay match o falla.
    //
    //    Antes esta lista pintaba el fallback DIRECTO, así que la misma orden
    //    mostraba "Descargar PDF/XML" en "Solo mías" (nativo) y solo "Ver
    //    factura" en "Todas". Reporte del cliente: los botones cambian entre
    //    pestañas. La única diferencia entre vistas debe ser QUÉ órdenes salen.
    if (order.has_invoice) {
      var box = el('div', 'pp-order__invoice-dl');
      box.setAttribute('data-pp-invoice-dl', '');
      box.setAttribute('data-order-number', orderNumber);
      box.setAttribute('data-t-pdf', t('download-pdf'));
      box.setAttribute('data-t-xml', t('download-xml'));

      var loading = el('span', 'pp-orders__action pp-orders__action--loading');
      loading.setAttribute('data-pp-invoice-loading', '');
      loading.setAttribute('aria-label', t('invoice-loading'));
      var spin = el('span', 'pp-spin');
      spin.setAttribute('aria-hidden', 'true');
      loading.appendChild(spin);
      box.appendChild(loading);

      var dlBtn = el('button', 'pp-orders__action pp-orders__action--download');
      dlBtn.type = 'button';
      dlBtn.setAttribute('data-pp-fact-open', '');
      dlBtn.setAttribute('data-pp-invoice-fallback', '');
      dlBtn.setAttribute('data-order-number', orderNumber);
      dlBtn.setAttribute('data-order-total-cents', String(cents));
      dlBtn.hidden = true;
      dlBtn.appendChild(svgIcon('download'));
      dlBtn.appendChild(document.createTextNode(t('view-invoice')));
      box.appendChild(dlBtn);

      return box;
    }

    // 2. Pago pendiente → gate ámbar; SÍ abre el modal (el cliente ve qué va
    //    a facturar + el mensaje de pago pendiente, replicado del nativo).
    if (order.financial_status !== 'paid') {
      var pendingBtn = el('button', 'pp-orders__action pp-orders__action--invoice-pending');
      pendingBtn.type = 'button';
      pendingBtn.setAttribute('data-pp-fact-open', '');
      pendingBtn.setAttribute('data-order-number', orderNumber);
      pendingBtn.setAttribute('data-order-total-cents', String(cents));
      pendingBtn.setAttribute('data-order-items', buildOrderItemsJson(items));
      pendingBtn.setAttribute('data-order-date', order.created_at || '');
      pendingBtn.setAttribute('data-order-paid', 'false');
      var pendingTip = t('invoice-pending-tooltip');
      if (pendingTip) pendingBtn.setAttribute('title', pendingTip);
      pendingBtn.appendChild(svgIcon('pending'));
      pendingBtn.appendChild(document.createTextNode(t('invoice-pending-payment')));
      return pendingBtn;
    }

    // 3. Pagada y dentro de la ventana → CTA activo de facturar.
    if (isInvoiceWindowOpen(order.created_at)) {
      var ctaBtn = el('button', 'pp-orders__action pp-orders__action--invoice-cta');
      ctaBtn.type = 'button';
      ctaBtn.setAttribute('data-pp-fact-open', '');
      ctaBtn.setAttribute('data-order-number', orderNumber);
      ctaBtn.setAttribute('data-order-total-cents', String(cents));
      ctaBtn.setAttribute('data-order-items', buildOrderItemsJson(items));
      ctaBtn.setAttribute('data-order-date', order.created_at || '');
      ctaBtn.setAttribute('data-order-paid', 'true');
      ctaBtn.appendChild(svgIcon('invoice'));
      ctaBtn.appendChild(document.createTextNode(t('cta-facturar')));
      return ctaBtn;
    }

    // 4. Pagada, mes ya cerrado → estado pasivo, NO clickeable (<span>, sin
    //    data-pp-fact-open, igual que el nativo).
    var closedSpan = el('span', 'pp-orders__action pp-orders__action--invoice-closed');
    var closedTip = t('invoice-closed-tooltip');
    if (closedTip) closedSpan.setAttribute('title', closedTip);
    closedSpan.appendChild(svgIcon('closed'));
    closedSpan.appendChild(document.createTextNode(t('invoice-closed')));
    return closedSpan;
  }

  // ── Construcción de una tarjeta ─────────────────────────────────────────
  function buildCard(order) {
    var items = Array.isArray(order.items) ? order.items : [];
    var li = el('li', 'pp-orders__card');

    // Header: meta (fecha · # · total) + badges (fulfillment · financial ·
    // facturada) + chip "Tuya" / "Puesta por [nombre]".
    var header = el('header', 'pp-orders__card-header');

    var metaWrap = el('div', 'pp-orders__header-meta');
    metaWrap.appendChild(buildHeaderBlock(t('placed-label'), formatDate(order.created_at)));
    metaWrap.appendChild(buildHeaderBlock(t('number-label'), order.order_number != null ? String(order.order_number) : ''));
    metaWrap.appendChild(buildHeaderBlock(t('total-label'), formatMoneyTotal(order.total)));

    // "Puesta por" era un badge perdido entre los de estatus; ahora es columna,
    // igual que en la lista nativa de "Solo mías". Para las propias mostramos el
    // nombre del cliente en sesión en vez de "Tuya": en una columna que dice
    // PUESTA POR, un nombre se lee mejor que un adjetivo.
    var placedBy = order.is_mine
      ? (root.getAttribute('data-customer-name') || t('placed-by-you'))
      : (order.placed_by || '');
    if (placedBy) metaWrap.appendChild(buildHeaderBlock(t('placed-by-label'), truncate(placedBy, 24)));

    // Nombre de la DIRECCIÓN de envío. El backend manda shipping_address = null
    // cuando la orden no trae address1 (≈15%), por eso el guard.
    var shipName = order.shipping_address && order.shipping_address.name;
    if (shipName) metaWrap.appendChild(buildHeaderBlock(t('ship-to-label'), truncate(shipName, 24)));

    header.appendChild(metaWrap);

    var badges = el('div', 'pp-orders__header-badges');

    badges.appendChild(buildBadge(fulfillmentMeta(order)));
    badges.appendChild(buildBadge(financialMeta(order.financial_status)));

    var invoiceMeta = order.has_invoice
      ? { label: t('invoiced'), cls: 'pp-orders__badge--paid', tip: t('invoiced-tip') }
      : { label: t('not-invoiced'), cls: 'pp-orders__badge--neutral', tip: t('not-invoiced-tip') };
    badges.appendChild(buildBadge(invoiceMeta));

    header.appendChild(badges);
    li.appendChild(header);

    // Body: grid de los top 3 (el backend ya ordena quantity desc).
    var body = el('div', 'pp-orders__card-body');
    var top3 = items.slice(0, 3);

    // Destino del detalle (2026-09-04): las órdenes PROPIAS tienen página
    // completa — /pages/cliente-orden?orden=N (taller/print, pago, factura,
    // ayuda; el mismo detalle del template viejo). Las de COMPAÑEROS no:
    // Liquid no ve órdenes ajenas, así que conservan el acordeón inline
    // (decisión 2026-07-27).
    // Cuenta demo: el pedido ficticio no existe en Shopify; su detalle lo
    // pinta /pages/cliente-orden?pedido=<id> desde el servidor (ver
    // PPCuentaDemo.aOrdenDeLista en pp-cuenta-demo.js).
    var detalleUrl = order.detalle_url
      ? order.detalle_url
      : order.is_mine && order.order_number != null
      ? '/pages/cliente-orden?orden=' + encodeURIComponent(String(order.order_number).replace(/^#/, ''))
      : null;

    body.appendChild(buildItemsList(top3, detalleUrl));

    // El cuerpo ENTERO honra su hover (se oscurece = es clickeable):
    // propia navega al detalle; compañero abre el acordeón (toggleDetalle
    // se define abajo, la referencia vive por cierre). Links y botones
    // internos conservan su propio destino.
    body.classList.add('pp-orders__card-body--clickable');
    body.addEventListener('click', function (e) {
      if (e.target.closest('a, button')) return;
      if (detalleUrl) window.location.href = detalleUrl;
      else if (toggleDetalle) toggleDetalle();
    });
    var toggleDetalle = null;

    if (items.length > 3) {
      var more;
      if (detalleUrl) {
        more = document.createElement('a');
        more.className = 'pp-orders__more-link';
        more.href = detalleUrl;
      } else {
        more = el('span', 'pp-orders__more-link');
      }
      more.textContent = moreItemsText(items.length - 3) + ' →';
      body.appendChild(more);
    }
    li.appendChild(body);

    // Acordeón inline: SOLO para órdenes de compañeros (las propias navegan
    // a la página). Cada sub-sección degrada con gracia: si el backend no
    // manda el campo (aún), simplemente no se renderiza (ver buildDetailInfo/
    // buildSummarySection).
    var allItemsWrap = null;
    if (!detalleUrl) {
      allItemsWrap = el('div', 'pp-orders__all-items');
      allItemsWrap.hidden = true;
      var detailInfo = buildDetailInfo(order);
      if (detailInfo) allItemsWrap.appendChild(detailInfo);
      allItemsWrap.appendChild(buildItemsList(items));
      allItemsWrap.appendChild(buildSummarySection(order));
      li.appendChild(allItemsWrap);
    }

    // Footer: Comprar nuevamente · Rastrear (si aplica) · Comentarios ·
    // Ver detalle (acordeón) · Facturar.
    var footer = el('footer', 'pp-orders__card-actions');

    if (items.length > 0) {
      var repurchaseBtn = el('button', 'pp-orders__action pp-orders__action--primary');
      repurchaseBtn.type = 'button';
      repurchaseBtn.setAttribute('data-pp-repurchase', '');
      var repurchaseItems = items
        .filter(function (it) {
          return it.variant_id != null;
        })
        .map(function (it) {
          return { id: it.variant_id, quantity: it.quantity };
        });
      repurchaseBtn.setAttribute('data-pp-repurchase-items', JSON.stringify(repurchaseItems));
      repurchaseBtn.appendChild(svgIcon('repurchase'));
      repurchaseBtn.appendChild(document.createTextNode(t('action-repurchase')));
      wireRepurchase(repurchaseBtn);
      footer.appendChild(repurchaseBtn);
    }

    if ((order.fulfillment_status === 'fulfilled' || order.fulfillment_status === 'partial') && order.tracking_url) {
      var trackA = document.createElement('a');
      trackA.className = 'pp-orders__action';
      trackA.href = order.tracking_url;
      trackA.target = '_blank';
      trackA.rel = 'noopener';
      trackA.appendChild(svgIcon('tracking'));
      trackA.appendChild(document.createTextNode(t('action-tracking')));
      footer.appendChild(trackA);
    }

    var feedbackA = document.createElement('a');
    feedbackA.className = 'pp-orders__action';
    var subject = t('feedback-subject').replace('__ORDER__', order.order_number != null ? String(order.order_number) : '');
    feedbackA.href = 'mailto:soporte@parapaquetes.com?subject=' + encodeURIComponent(subject);
    feedbackA.appendChild(svgIcon('feedback'));
    feedbackA.appendChild(document.createTextNode(t('action-feedback')));
    footer.appendChild(feedbackA);

    if (detalleUrl) {
      // Orden propia: "Ver detalle" navega a LA PÁGINA completa.
      var detailA = document.createElement('a');
      detailA.className = 'pp-orders__action';
      detailA.href = detalleUrl;
      detailA.appendChild(svgIcon('detail'));
      detailA.appendChild(document.createTextNode(t('action-detail')));
      footer.appendChild(detailA);
    } else {
      var detailBtn = el('button', 'pp-orders__action');
      detailBtn.type = 'button';
      detailBtn.setAttribute('data-pp-toggle-detail', '');
      detailBtn.setAttribute('aria-expanded', 'false');
      detailBtn.appendChild(svgIcon('detail'));
      detailBtn.appendChild(document.createTextNode(t('action-detail')));
      toggleDetalle = function () {
        var expanded = li.classList.toggle('is-expanded');
        allItemsWrap.hidden = !expanded;
        detailBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      };
      detailBtn.addEventListener('click', toggleDetalle);
      footer.appendChild(detailBtn);
    }

    footer.appendChild(buildInvoiceAction(order, items));

    li.appendChild(footer);

    return li;
  }

  // ── Estado + fetch de la lista ──────────────────────────────────────────
  var state = { scope: 'all', page: 0, pageSize: 20, total: 0, loading: false, nativeFallback: false };

  function setActiveScope(scope) {
    scopeBtns.forEach(function (btn) {
      var active = btn.getAttribute('data-pp-scope') === scope;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function renderPageInfo() {
    var totalPages = Math.max(1, Math.ceil(state.total / (state.pageSize || 20)));
    if (pageInfoEl) pageInfoEl.textContent = state.total > 0 ? (state.page + 1) + ' / ' + totalPages : '';
    if (prevBtn) prevBtn.disabled = state.page <= 0;
    if (nextBtn) nextBtn.disabled = state.page + 1 >= totalPages;
    if (paginationNav) paginationNav.hidden = totalPages <= 1;
    // Chip del H1: mismo total que se está listando ahora mismo (el de la
    // empresa en scope "all", o el del cliente en scope "mine") — el chip
    // es un número plano en el nativo (sin texto "N órdenes"), así que solo
    // seteamos el número. Con el fallback nativo activo, el chip ya lo
    // restauró el catch (initialCount) y NO se pisa con el total=0 del error.
    if (countEl && !state.nativeFallback) countEl.textContent = String(state.total);
  }

  function clearList() {
    while (listEl.firstChild) listEl.removeChild(listEl.firstChild);
  }

  // Esqueletos mientras carga. Antes el clearList() dejaba la lista en blanco
  // los ~1-3s que tarda el GET al CRM, y al cliente le parecía que la página
  // se rompía. Se pintan con la misma forma que las cards reales (header de 5
  // columnas + una fila de producto) para que no brinque el layout al llegar.
  function renderSkeleton(n) {
    var frag = document.createDocumentFragment();
    for (var i = 0; i < n; i++) {
      var li = el('li', 'pp-orders__card pp-orders__card--skel');
      li.setAttribute('aria-hidden', 'true');

      var head = el('div', 'pp-orders__header-meta');
      for (var c = 0; c < 5; c++) {
        var blk = el('div', 'pp-orders__header-block');
        blk.appendChild(el('span', 'pp-skel pp-skel--text pp-skel-col__label'));
        blk.appendChild(el('span', 'pp-skel pp-skel--title pp-skel-col__value'));
        head.appendChild(blk);
      }
      li.appendChild(head);

      var row = el('div', 'pp-skel-list__row');
      row.appendChild(el('span', 'pp-skel pp-skel-list__thumb'));
      var lines = el('div', 'pp-skel-list__lines');
      lines.appendChild(el('span', 'pp-skel pp-skel--title'));
      lines.appendChild(el('span', 'pp-skel pp-skel--text'));
      row.appendChild(lines);
      li.appendChild(row);

      frag.appendChild(li);
    }
    listEl.appendChild(frag);
  }

  function fetchOrders(scope, page) {
    var url = ORDERS_ENDPOINT + '?scope=' + encodeURIComponent(scope) + '&page=' + encodeURIComponent(page);
    return fetch(url, { method: 'GET', credentials: 'same-origin' }).then(function (r) {
      return r.json().catch(function () {
        return null;
      });
    });
  }

  // Prefetch de "Todas". El GET al CRM tarda ~1-3s; se dispara en cuanto
  // sabemos que el cliente tiene empresa, así que para cuando le pica a la
  // pestaña la respuesta normalmente ya llegó y el cambio se siente instantáneo.
  // TTL corto y de un solo uso: una orden nueva del equipo debe aparecer, así
  // que la segunda visita a la pestaña vuelve a pedir fresco.
  var PREFETCH_TTL = 60000;
  var prefetched = null;

  function prefetchAll() {
    var entry = { ts: Date.now(), promise: fetchOrders('all', 0) };
    entry.promise.catch(function () {
      if (prefetched === entry) prefetched = null;
    });
    prefetched = entry;
  }

  function takePrefetch(scope, page) {
    if (scope !== 'all' || page !== 0 || !prefetched) return null;
    var entry = prefetched;
    prefetched = null;
    if (Date.now() - entry.ts > PREFETCH_TTL) return null;
    return entry.promise;
  }

  function load(scope, page) {
    if (state.loading) return;
    state.loading = true;
    state.scope = scope;
    state.page = page;
    state.nativeFallback = false;
    if (nativeBlock) nativeBlock.hidden = true;
    setActiveScope(scope);
    clearList();
    if (emptyEl) emptyEl.hidden = true;

    // Esqueletos: inmediatos si NO hay prefetch (camino frío, el GET tarda
    // ~2s y el cliente se quedaría viendo el vacío). Con prefetch se retrasan
    // 120ms para que, si ya llegó, no se vea ni un parpadeo de shimmer.
    //
    // Que el camino lento NO dependa de un setTimeout es a propósito: Chrome
    // estrangula los timers en pestañas de segundo plano (medido: un timer de
    // 120ms tardó 437ms con la pestaña oculta). El caso que importa se pinta
    // en el mismo task del clic.
    var warm = takePrefetch(scope, page);
    var skelTimer = null;
    if (warm) {
      skelTimer = setTimeout(function () {
        renderSkeleton(5);
      }, 120);
    } else {
      renderSkeleton(5);
    }

    (warm || fetchOrders(scope, page))
      .then(function (data) {
        clearTimeout(skelTimer);
        clearList();
        if (!data || data.found === false || !Array.isArray(data.orders)) {
          state.total = 0;
          if (emptyEl) emptyEl.hidden = false;
          return;
        }

        state.total = data.total || 0;
        state.pageSize = data.page_size || state.pageSize;

        if (data.orders.length === 0) {
          if (emptyEl) emptyEl.hidden = false;
        } else {
          data.orders.forEach(function (order) {
            listEl.appendChild(buildCard(order));
          });
          // Las cards nacen después del DOMContentLoaded que dispara a
          // pp-customer-order.js, así que sus slots [data-pp-invoice-dl] se
          // quedarían con el spinner pegado para siempre. Este evento le pide
          // resolverlos; usa su cache de sesión (TTL 3 min), no re-pega al CRM.
          document.dispatchEvent(new CustomEvent('pp:orders-rendered'));
        }
      })
      .catch(function () {
        clearTimeout(skelTimer);
        clearList();
        state.total = 0;
        // Degradación con gracia: si "Solo mías" no pudo cargar del backend,
        // el bloque nativo de Liquid (garantizado por el servidor) es mejor
        // que un vacío mentiroso — aunque sus links salgan a la página
        // hospedada. "Todas" no tiene nativo: ahí sí, estado vacío.
        if (scope === 'mine' && nativeBlock) {
          nativeBlock.hidden = false;
          state.nativeFallback = true;
          if (countEl && initialCount !== null) countEl.textContent = initialCount;
        } else if (emptyEl) {
          emptyEl.hidden = false;
        }
      })
      .finally(function () {
        state.loading = false;
        renderPageInfo();
      });
  }

  // "Solo mías" (rework 2026-09-04): TAMBIÉN se pinta con la lista JS
  // (scope=mine del backend), no con el bloque nativo. Razón: bajo cuentas
  // NUEVAS `order.customer_url` ya no rinde nuestro template — manda a la
  // página hospedada de Shopify (account.parapaquetes.com), otro diseño.
  // El acordeón "Ver detalle" ES el detalle (decisión de diseño 2026-07-27)
  // y trae todo: domicilio, entrega, guía, items y totales. El bloque nativo
  // queda SOLO como fallback si el fetch de "mine" falla (ver load()).
  function showMine() {
    if (nativeBlock) nativeBlock.hidden = true;
    load('mine', 0);
  }

  function showAll() {
    if (nativeBlock) nativeBlock.hidden = true;
    load('all', 0);
  }

  scopeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var scope = btn.getAttribute('data-pp-scope');
      if (!scope || scope === state.scope) return;
      if (scope === 'mine') showMine();
      else showAll();
    });
  });

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      if (state.page > 0) load(state.scope, state.page - 1);
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      var totalPages = Math.max(1, Math.ceil(state.total / (state.pageSize || 20)));
      if (state.page + 1 < totalPages) load(state.scope, state.page + 1);
    });
  }

  // ── Cuenta DEMO (22-oct-2026) ──────────────────────────────────────────
  // Con la etiqueta `pp-demo` (snippets/pp-cuenta-demo.liquid) la sección ya
  // NO rinde el bloque nativo (serían los pedidos REALES de la persona) y
  // marca este contenedor con data-pp-demo. La lista sale de
  // /apps/crm/customer-demo con las MISMAS tarjetas (buildCard). Sin empresa
  // ficticia no hay «Todas / Solo mías»: el toggle se esconde. Si el endpoint
  // falla o no trae pedidos, el estado vacío de siempre.
  function loadDemo() {
    var CD = window.PPCuentaDemo;
    var toggle = root.querySelector('.pp-company-orders__toggle');
    var hint = root.querySelector('.pp-company-orders__hint');
    // Se quitan (no `hidden`): el CSS les pone display:inline-flex y le gana.
    if (toggle && toggle.parentNode) toggle.parentNode.removeChild(toggle);
    if (hint && hint.parentNode) hint.parentNode.removeChild(hint);
    root.hidden = false;
    clearList();
    renderSkeleton(5);
    (CD ? CD.pedir() : Promise.resolve(null)).then(function (d) {
      clearList();
      var lista = CD ? CD.pedidos(d) : [];
      if (countEl) countEl.textContent = String(lista.length);
      if (!lista.length) {
        if (emptyEl) emptyEl.hidden = false;
        return;
      }
      lista.forEach(function (p) {
        listEl.appendChild(buildCard(CD.aOrdenDeLista(p)));
      });
      document.dispatchEvent(new CustomEvent('pp:orders-rendered'));
    });
  }

  if (root.hasAttribute('data-pp-demo')) {
    loadDemo();
    return;
  }

  // ── Bootstrap: ¿el cliente pertenece a una empresa? ─────────────────────
  fetch(COMPANY_ENDPOINT, { method: 'GET', credentials: 'same-origin' })
    .then(function (r) {
      return r.json().catch(function () {
        return null;
      });
    })
    .then(function (d) {
      if (!d || d.found !== true) return; // sin empresa → nativo intacto
      // Muestra el toggle y arranca en "Solo mías" — desde el rework
      // 2026-09-04 TAMBIÉN por JS (scope=mine): el nativo solo reaparece
      // como fallback de error. "Todas" (empresa) es un clic.
      root.hidden = false;
      showMine();
      // Calienta "Todas" desde ya: el cliente arranca en "Solo mías", así
      // que este GET corre en paralelo sin competir con un render nativo.
      prefetchAll();
    })
    .catch(function () {});
})();
